// 药品相关

export default [
  /**
   * 电子病历
   */
  {
    path: '/medical-record/electronic/list',
    component: () => import('../pages/medical-record/electronic-medical-record.vue')
  }
]



// WEBPACK FOOTER //
// ./h5/router/medicalRecord.js